import { Injectable, NgZone } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import {
  ActionPerformed,
  PushNotificationSchema,
  PushNotifications,
  Token,
} from '@capacitor/push-notifications';
import { AuthService } from './auth.service';
import { GlobalVariablesService } from '../global-variables.service';
import { FirebaseCrashlytics } from '@capacitor-community/firebase-crashlytics';
import { Haptics } from '@capacitor/haptics';
import { ToastService } from './toast.service';
import { EventNotificationService } from './event-notification.service';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class FcmService {

  constructor(private authService: AuthService,
              public gvs: GlobalVariablesService,
              private ngZone: NgZone,
              private eventNotification: EventNotificationService,
              public platform: Platform,
              private toastService: ToastService) { }

  public async initPush() {
    if (Capacitor.getPlatform() !== 'web') {
      try{
        let permStatus = await PushNotifications.checkPermissions();
        if (permStatus.receive === 'prompt' || permStatus.receive === 'granted') {
          PushNotifications.requestPermissions().then(result => {
            if (result.receive === 'granted') {
              // Register with Apple / Google to receive push via APNS/FCM
              PushNotifications.register();
            }
          });
        }
        
      }catch(err){
        const message = JSON.stringify(err);
        await FirebaseCrashlytics.recordException({message: message});
      }
      try{
        PushNotifications.removeAllDeliveredNotifications();
      }catch(err){
        const message = JSON.stringify(err);
        await FirebaseCrashlytics.recordException({message: message});
      }
    }
  }

  public async registerPush() {
    await this.initPush();

    PushNotifications.addListener('registration', (token: Token) => {
      //alert('Push registration success, token: ' + token.value);
      this.authService.setDeviceId(token.value);
    });

    PushNotifications.addListener('registrationError', (error: any) => {
      //alert('Error on registration: ' + JSON.stringify(error));
      this.authService.setDeviceId(undefined);
    });

    PushNotifications.addListener(
      'pushNotificationReceived',
      async (notification: PushNotificationSchema) => {
        notification.data.type = 'foreground';
        Haptics.vibrate();
        this.ngZone.run(() => {
          if (this.platform.is('android')){
            this.toastService.showPush(notification, (notification) => this.eventNotification.notifications.next(notification))
          }
        })
        //alert('Push received: ' + JSON.stringify(notification));
      },
    );

    PushNotifications.addListener(
      'pushNotificationActionPerformed',
      (notification: ActionPerformed) => {
        notification.notification.data.type = 'background';
        this.eventNotification.notifications.next(notification)
        //alert('Push action performed: ' + JSON.stringify(notification));
      },
    );
  }
}
